import { mutate } from '@/service/apollo/client'
import { gql } from '@apollo/client'

const register = ({ userName, email, password }) => mutate(gql`
  mutation {
    register(input: { 
      username: "${userName}", 
      email: "${email}", 
      password: "${password}",
    }) {
      jwt
      user {
        username
        id
        email
      }
    }
  }
`)

const login = ({ email, password }) => mutate(
  gql`
    mutation {
      login(input: { identifier: "${email}", password: "${password}" }) {
        jwt
        user {
          username
          id
          email
        }
      }
    }
  `
)

const forgotPassword = ({ email }) => mutate(
  gql`
    mutation {
      forgotPassword (email: "${email}") {
        ok
      }
    }
  `
)

const resetPassword = ({ password, confirmPassword, code }) => mutate(
  gql`
    mutation {
      resetPassword (password: "${password}", passwordConfirmation: "${confirmPassword}", code: "${code}" ) {
        user {
          username
          email
        }
      }
    }
  `
)

export {
  register,
  login,
  resetPassword,
  forgotPassword
}
